import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/skin-tone-changer"
    exact
    path="/consumer/features/skin-tone-changer"
    component={AsyncPage}
  />,
];
